/* eslint-disable import/prefer-default-export */
export const removeHtml = (value) => {
  if (!value) return value;

  const doc = new DOMParser().parseFromString(value, 'text/html');

  return doc.body.textContent || '';
};
